var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99463 6C6.93695 6 8.76659 7.34491 9.76458 9.51365C10.2636 10.6005 9.95237 11.8561 8.99194 12.6352C8.06371 13.3896 6.92085 13.8561 5.69215 13.9851L5.62777 13.9901C5.41851 13.995 5.20926 14 5 14C4.79075 14 4.58149 13.995 4.37223 13.9901L4.30785 13.9851C3.07378 13.8561 1.93093 13.3896 1.00806 12.6352C0.0476324 11.8561 -0.263567 10.6005 0.235426 9.51365C1.22268 7.34491 3.05232 6 4.99463 6Z",
    fill: "#34657F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98467 5.25826C3.52821 5.25826 2.33948 4.08024 2.33948 2.62913C2.33948 1.17802 3.52285 0 4.98467 0C6.44113 0 7.62986 1.17802 7.62986 2.62913C7.62986 4.08024 6.44113 5.25826 4.98467 5.25826Z",
    fill: "#34657F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailIcon);
export default __webpack_public_path__ + "static/media/retail-icon.66a1d5601119be7fb8281a13b609fa2c.svg";
export { ForwardRef as ReactComponent };